import { render, staticRenderFns } from "./AdicionalesDetraccionCarga.vue?vue&type=template&id=c1b8bf1c&"
import script from "./AdicionalesDetraccionCarga.vue?vue&type=script&lang=js&"
export * from "./AdicionalesDetraccionCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports